import React from 'react';
import StarRatings from 'react-star-ratings';
import './RatingButton.css';

export class RatingButton extends React.Component {

  static getButtonId (id) {
    return `rating-button-${id}`;
  }

  static getIconId (id) {
    return `rating-icon-${id}`;
  }

  render () {
    const { id, className, rating } = this.props;
    return (
      <div id={ RatingButton.getButtonId(id) } className={ `rating-button-container ${!!className ? className : ''}` }>
        <StarRatings
          rating={rating}
          starRatedColor="#F3C300"
          starDimension="24px"
          starSpacing="0px"
        />
      </div>
    );
  }
}
